import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const BirthChartsDataContext = createContext();

const BirthChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.BIRTH_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/birth'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              occurrenceLocation: data?.occurrenceLocation ?? [],
              labor: data?.labor ?? [],
              presentation: data?.presentation ?? [],
              cesareansBeforeBirthStart: data?.cesareansBeforeBirthStart ?? [],
              typeOfBirth: data?.typeOfBirth ?? [],
              assistedBirth: data?.assistedBirth ?? []
          }
        : {
              occurrenceLocation: [],
              labor: [],
              presentation: [],
              cesareansBeforeBirthStart: [],
              typeOfBirth: [],
              assistedBirth: []
          };

    return (
        <BirthChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </BirthChartsDataContext.Provider>
    );
};

export default BirthChartsDataProvider;
